import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Resume } from './pages/Resume';
import { NotFound } from './pages/NotFound';

// Aurora is lazy-loaded — its code (and the Lab chunk it imports) only
// reaches a browser that actually navigates to /aurora/<knock>. The path
// pattern lives in the main bundle but no Aurora logic does.
// See docs/adr/0011-hidden-authenticated-area.md
const Aurora = lazy(() => import('./pages/Aurora'));

export function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/blog"       element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/resume"     element={<Resume />} />
          <Route
            path="/aurora/:knock"
            element={
              <Suspense fallback={null}>
                <Aurora />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
